exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-table[data-v-01a9c3c7] .el-loading-mask{background-color:rgba(255,255,255,0.6)}.common-table[data-v-01a9c3c7] .el-loading-spinner .path{stroke:#2675f1}[data-v-01a9c3c7] .common-table.el-table td{color:inherit}\n", ""]);

// exports
